/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Problem_3_TitleInputs */

const en_mk_problem_3_title = /** @type {(inputs: Mk_Problem_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing technical on staff`)
};

const id_mk_problem_3_title = /** @type {(inputs: Mk_Problem_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada yang teknis`)
};

/**
* | output |
* | --- |
* | "Nothing technical on staff" |
*
* @param {Mk_Problem_3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_problem_3_title = /** @type {((inputs?: Mk_Problem_3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Problem_3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_problem_3_title(inputs)
	return en_mk_problem_3_title(inputs)
});